package co.uk.paxes.pinpoint.model

import kotlinx.serialization.Serializable

@Serializable
enum class PinColor {
    RED,
    GREEN,
    PURPLE,
    YELLOW,
    BLACK // Used for reversed pins and jokers
}
